import * as React from "react";
import PropTypes from "prop-types";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";

const DetailsImage = ({ imageSrc, imageAlt }) => {
  return (
    <DarkModeInverter>
      {({ maybeInvert }) => {
        const imageStyle = {
          width: "100%",
          display: "block",
          ...maybeInvert,
        };
        const bodyStyle = {
          display: "inline-block",
          margin: "0.25em 1em",
          verticalAlign: "middle",
          maxWidth: "12em",
          backgroundColor: "black",
        };

        return (
          <div style={bodyStyle}>
            <img style={imageStyle} src={imageSrc} alt={imageAlt} />
          </div>
        );
      }}
    </DarkModeInverter>
  );
};
DetailsImage.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
};

export default DetailsImage;



// WEBPACK FOOTER //
// ./src/components/Details/DetailsImage.jsx